import { Modal, Box, Grid, IconButton, useTheme, Tooltip, Typography, TypographyProps } from "@mui/material";
import { MdClose } from "react-icons/md";

interface IProps {
    title?: string,
    description?: string | JSX.Element,
    open: boolean,
    children: React.ReactNode,
    onClose?: () => void,
    showButtonClose?: boolean,
    titleProps?: TypographyProps,
    descriptionProps?: TypographyProps,
    withoutHeader?: boolean
}

export const ModalComponent = ({
    title,
    description,
    open,
    children,
    onClose,
    showButtonClose = true,
    titleProps,
    descriptionProps,
    withoutHeader
}: IProps) => {
    const { spacing } = useTheme()
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box>
                <Grid
                    container
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    flexWrap={"nowrap"}
                >
                    {!withoutHeader && <Typography id="modal-title" fontSize={"1.6rem"} fontWeight={600} {...titleProps}>{title}</Typography>}
                    {(showButtonClose && !withoutHeader)
                        &&
                        <Tooltip title={"Fechar modal"}>
                            <IconButton
                                sx={{
                                    width: spacing(5),
                                    height: spacing(5)
                                }}
                                onClick={onClose}
                            >
                                <MdClose size={20} />
                            </IconButton>
                        </Tooltip>
                    }
                </Grid>
                {(description && !withoutHeader) && <Typography id="modal-description" fontSize={"1.4rem"} fontWeight={400} sx={{ opacity: 0.5 }} {...descriptionProps}>{description}</Typography>}
                <br />
                {children}
                <br />
            </Box>
        </Modal>
    );
};
